import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
const API = `${process.env.REACT_APP_BACKEND_URL}/api/project-progress`;

export const usePlannedCosts = (projectId, enabled, jobs, currency) => {
  const [state, setState] = useState({ data: null, loading: false, error: false });
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    if (!projectId || !enabled) return;
    const controller = new AbortController();
    setState({ data: null, loading: true, error: false });
    axios.get(`${API}/${projectId}/planned-costs`, { signal: controller.signal })
      .then(({ data }) => setState({ data, loading: false, error: false }))
      .catch(error => { if (!axios.isCancel(error)) setState({ data: null, loading: false, error: true }); });
    return () => controller.abort();
  }, [projectId, enabled, jobs, currency, revision]);
  const saveArea = async value => {
    await axios.put(`${API}/${projectId}/planned-cost-settings`, { planned_cost_area_m2: value });
    refresh();
  };
  return { ...state, data: state.data?.project_id === projectId ? state.data : null, refresh, saveArea };
};